import React, { Suspense, useEffect, useState } from "react";
import { renderRoutes } from "react-router-config";
import { ProgressBar, Container, Row, Col, Image } from "react-bootstrap";

import PropTypes from "prop-types";

//import { NavBar, TopBar } from "components";
import { apicontrol } from "services/api";
import "../styles.css";

const logo = {
  display: "flex",
  justifyContent: "center",
};

const Login = (props) => {
  const { route } = props;

  const [imgBackground, setImgBackground] = useState();
  const [imgLogo, setImgLogo] = useState();

  useEffect(() => {
    const getImages = async () => {
      const response = await apicontrol().get("/config_services");
      const background = response.data.config
        ? response.data.config.backgroundLogin.public_url
        : "";
      const logo = response.data.config
        ? response.data.config.logo.public_url
        : "";

      setImgBackground(background);
      setImgLogo(logo);

      localStorage.setItem("@authenticator/logo", logo);
    };

    getImages();
  }, []);

  return (
    <div>
      <Container fluid>
        <Row>
          <Col sm={8} className="p-0">
            <Image
              src={imgBackground}
              fluid
              style={{ height: "100vh", width: "100%" }}
              className="d-none d-sm-block"
            />
          </Col>
          <Col sm={4} className="p-5">
            <div style={logo}>
              <Image src={imgLogo} fluid style={{ margin: "50px" }} />
            </div>
            <Suspense fallback={<ProgressBar striped />}>
              {renderRoutes(route.routes)}
            </Suspense>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Login.propTypes = {
  route: PropTypes.object,
};

export default Login;
